import useMixingTokoText from 'hooks/business/useMixingTokoText';
import { useCallback } from 'react';
import { scenarioTypeI18nLabelMap } from '../Scenario/config';
import { isTiKTokUpperCase } from 'lib/utils/isTikTok';
import { useTranslate } from '@tolgee/react';

function useScenarioLabel() {
  const { t } = useTranslate();

  const {
    orderReminderTitle: { i18nKey: orderReminderI18nKey },
  } = useMixingTokoText();

  const getScenarioI18nKey = useCallback(
    (scenarioType: Marketing.AllScenarioType, platform: General.PlatformUpperCase): string => {
      if (scenarioType === 'ORDER_REMINDER') {
        return orderReminderI18nKey;
      }

      if (scenarioType === 'CANCELLING_TRADE_MODIFY_ORDER' && platform === 'LAZADA') {
        return 'aide.修改订单';
      }

      if (isTiKTokUpperCase(platform)) {
        if (scenarioType === 'PRAISE_REMINDER') {
          return '邀请评价';
        }
        if (scenarioType === 'RETURN_TRADE_ITEM_DIFF') {
          return 'aide.收到货物与介绍不符';
        }

        if (scenarioType === 'CANCELLING_TRADE_OTHERS') {
          return 'aide.其他';
        }

        if (scenarioType === 'CANCELLING_TRADE_MODIFY_ORDER') {
          return 'aide.修改订单';
        }

        if (scenarioType === 'CANCELLING_TRADE_CHANGE_MIND') {
          return 'aide.不想买了';
        }
      }

      return scenarioTypeI18nLabelMap[scenarioType];
    },
    [orderReminderI18nKey],
  );

  const getScenarioLabel = useCallback(
    (scenarioType: Marketing.AllScenarioType, platform: General.PlatformUpperCase) => {
      return t(getScenarioI18nKey(scenarioType, platform)) as string;
    },
    [t, getScenarioI18nKey],
  );

  return {
    t,
    getScenarioLabel,
    getScenarioI18nKey,
  };
}

export default useScenarioLabel;
